import posthog from "posthog-js";
import { VALID_EVENTS } from "./posthogEvents.js";

/**
 * Thin wrapper around posthog.capture() that validates event names against the
 * registry and logs warnings in development for unknown events.
 */
const capture = (eventName, properties = {}) => {
  if (import.meta.env.DEV && !VALID_EVENTS.has(eventName)) {
    console.warn(`[PostHog] Unknown event: ${eventName}`);
  }
  posthog.capture(eventName, properties);
};

/**
 * Capture an event with shop group context attached.
 */
const captureWithShop = (eventName = "", properties = {}, shopId = 0) => {
  capture(eventName, {
    ...properties,
    $groups: shopId ? { shop: String(shopId) } : {},
  });
};

const captureException = (error, properties = {}) => {
  try {
    posthog.captureException(error, properties);
  } catch {
    // PostHog unavailable: the server report still records the crash
  }
};

const getPostHogDistinctId = () => {
  try {
    return posthog.get_distinct_id?.() ?? null;
  } catch {
    return null;
  }
};

export { capture, captureException, captureWithShop, getPostHogDistinctId };
